<template>
    <div class="form-group">
        <label :for="myId" :class="labelWidth">{{ name | capitalize }}</label>
        <div v-if="isRow" :class="inputWidth">
            <input :type="type" class="form-control" :class="{'border-danger': myErrors.length}" :value="myValue"
                @input="update" @change="update" :id="myId" :disabled="disabled" :placeholder="placeholder">
        </div>
        <template v-else>
            <input :type="type" class="form-control" :class="{'border-danger': myErrors.length}" :value="myValue"
                @input="update" @change="update" :id="myId" :disabled="disabled" :placeholder="placeholder">
        </template>
        <div v-if="isRow" class="col-12">
            <small class="form-text text-danger" v-for="(error, index) in myErrors" :key="index" v-text="error"></small>
        </div>
        <template v-else>
            <small class="form-text text-danger" v-for="(error, index) in myErrors" :key="index" v-text="error"></small>
        </template>
    </div>
</template>
<script>
    import InputBase from './InputBase';

    export default {
        extends: InputBase
    }
</script>
<style lang="">

</style>